module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAaCAYAAACpSkzOAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAABgSURBVEiJ7ZAxEoAwCAS38F+eLzM/059pg0UaBZNUYWcYGmABSJIkmQMBZfB8YZJrgEzAYVHRU/gI9FbUIgz3RhuE84q/wmaBR/i1RMUSEAHsllfLG3A6Z4QpdHpTMik3cXcbtJwPcb8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/down-icon.png
// module id = xFWD
// module chunks = 1